<template>
  <v-row justify="center">
    <v-dialog v-if="isVisible" v-model="dialog" persistent scrollable max-width="800px" >
      <template v-slot:activator="{ on }">
        <v-btn color="rtsPrimary" dark v-on="on">Add Order</v-btn>
      </template>
      <v-card>
        <v-card-title fixed>
          <span class="headline">Add New Order</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-progress-linear
          v-if="loading"
          indeterminate
        ></v-progress-linear>
        <v-card-text style="height: 500px;">
          <v-container>
            <v-form ref="form">
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field :disabled="loading" label="Client Ref#" v-model="order.client_reference" required :rules="[v => !!v || 'Client Ref# is required']"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <AutoComplete :disabled="loading" :default="null" :required="required" :rules="[v => !!v || 'Customer is required']" label="Customer*" itemText="name" url="clients/?slug__contains=" field="client" type="foriegn" @clicked="getAutoCompleteData" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <AutoComplete :disabled="loading" :default="null" label="Product*" :required="required" :rules="[v => !!v || 'Product is required']" itemText="name" url="products/?slug__contains=" field="product" type="foriegn" @clicked="getAutoCompleteData" @valueCleared="productCleared" />
              </v-col>
              <v-col cols="12" sm="6" md="8">
                <v-text-field :disabled="loading" label="Property Address" v-model="order.addressLine" required :rules="[v => !!v || 'Property Address is required']" ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field :disabled="loading" label="Zip Code*" v-model="order.zip_code" required :rules="[v => !!v || 'Zip code is required']" ></v-text-field>
              </v-col>
              <!--
              <v-col cols="12" sm="6" md="4">
                  <AutoComplete :default="null" label="City" itemText="name" url="cities/?slug__contains=" field="city" type="foriegn" @clicked="getAutoCompleteData" />
              </v-col>
              -->
              <v-col cols="12" sm="6" md="6">
                  <AutoComplete :disabled="loading" :default="null" :required="required" :rules="[v => !!v || 'State is required']" label="State*" itemText="name" url="states/?slug__contains=" field="state" type="foriegn" @clicked="getAutoCompleteData" />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <AutoComplete :disabled="loading" :default="defaultCounty" label="County*" :required="required" :rules="[v => !!v || 'County is required']" itemText="name" :url="countyURL" field="county" type="foriegn" @clicked="getAutoCompleteData" />
              </v-col>
              <v-col cols="12">
                <v-text-field :disabled="loading" label="Loan#" v-model="order.loan"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field :disabled="loading" label="Price" v-model="order.price"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field :disabled="loading" label="Subject Lien Amount" v-model="order.subject_lien_amount"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <v-text-field :disabled="loading" label="First Borrower" v-model="order.first_borrower"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field :disabled="loading" label="Last 4 of ssn" v-model="order.last_4_of_ssn"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <v-text-field :disabled="loading" label="Second Borrower" v-model="order.second_borrower"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field :disabled="loading" label="Last 4 of ssn 2" v-model="order.last_4_of_ssn_2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DatePicker :disabled="loading" :pickerData="EffectiveDatePickerData" @clicked="getDateFromDatePicker"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DatePicker :disabled="loading" :pickerData="PriorEffectiveDatePickerData" @clicked="getDateFromDatePicker"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DatePicker :disabled="loading" :pickerData="SubjectLienPickerData" @clicked="getDateFromDatePicker"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DatePicker :disabled="loading" :pickerData="PrepareDatePickerData" @clicked="getDateFromDatePicker"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DatePicker :disabled="loading" :pickerData="SearchPdStDtPickerData" @clicked="getDateFromDatePicker"/>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <!-- <DatePicker :pickerData="OrderDuePickerData" @clicked="getDateFromDatePicker"/> -->
                <DateTimePicker :disabled="loading" :pickerData="OrderDuePickerData" @clicked="getDateFromDatePicker"/>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-switch :disabled="loading" v-model="order.on_hold" class="mx-2" label="On Hold"></v-switch>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="!shouldShowCustomUi" >
                <v-switch :disabled="loading" v-model="order.is_developer_deed" class="mx-2" label="Is Developer Deed"></v-switch>
              </v-col>
              <v-col cols="12" :sm="shouldShowCustomUi?'12':'6'" :md="shouldShowCustomUi?'12':'6'">
                <v-switch v-if="!shouldShowCustomUi" :disabled="loading" v-model="order.is_effective_date_changed" class="mx-2" label="Only Effective Date Changed"></v-switch>
                <div v-else>
                    <v-radio-group v-model="order.is_effective_date_changed" label="Only Effective Date Changed" class="radio-group-container" row>
                      <v-radio label="Only Effective Date Change" :value="true"></v-radio>
                      <v-radio label="New Recording Founds" :value="false"></v-radio>
                    </v-radio-group>
                  </div>
              </v-col>
              <v-col cols="12" :sm="shouldShowCustomUi?'12':'6'" :md="shouldShowCustomUi?'12':'6'">
                <v-switch v-if="!shouldShowCustomUi" :disabled="loading" v-model="order.borrower_name_in_title" class="mx-2" label="Borrower Name In Title"></v-switch>
                <div v-else>
                    <v-radio-group v-model="order.borrower_name_in_title" label="Borrower Name In Title" class="radio-group-container" row>
                      <v-radio label="Yes" :value="true"></v-radio>
                      <v-radio label="No" :value="false"></v-radio>
                    </v-radio-group>
                  </div>
              </v-col>
              <!--<v-col cols="12" sm="6" md="6">
                <v-switch :disabled="loading" v-model="order.new_pps_recordings_found" class="mx-2" label="New Recording Found"></v-switch>
              </v-col>-->
              <v-col cols="12">
                <v-textarea
                  :disabled="loading"
                  filled
                  v-model="order.note"
                  label="Order Note"
                  rows="4"
                  row-height="30"
                  shaped
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <AutoComplete :disabled="loading" :default="null" label="Stage*" :required="required" :rules="[v => !!v || 'Stage is required']" itemText="name" url="order_statuses/?slug__contains=" field="status" type="foriegn" @clicked="getAutoCompleteData" />
              </v-col>
              <v-col cols="12">
                <v-text-field :disabled="loading" label="TS Identifier#" v-model="order.ts_identifier"></v-text-field>
              </v-col>
            </v-row>
            </v-form>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions fixed>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false" :disabled="loading">Close</v-btn>
          <v-btn color="blue darken-1" text @click="createNewOrder()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import JwtService from '@/common/jwt.service'
import DatePicker from '@/components/datePicker.vue'
import DateTimePicker from '@/components/dateTimePicker.vue'
import AutoComplete from '@/components/autoComplete.vue'
import { ADDORDER, GETCLIENTPRODUCTFEES } from '@/store/actions.type'
import { PRODUCT_NAMES } from '@/constants'

export default {
  name: 'AddOrder',
  components: {
    DatePicker,
    DateTimePicker,
    AutoComplete
  },
  data: () => ({
    loading: false,
    dialog: false,
    EffectiveDatePickerData: { date: null, name: 'Effective Date', field: 'effective_date' },
    PriorEffectiveDatePickerData: { date: null, name: 'Prior Effective Date', field: 'prior_effective_date' },
    SubjectLienPickerData: { date: null, name: 'SubjectLien Date', field: 'subject_lien_date' },
    PrepareDatePickerData: { date: null, name: 'Prepare Date', field: 'prepared_date' },
    SearchPdStDtPickerData: { date: null, name: 'Search Pd St Date', field: 'search_pd_st_date' },
    OrderDuePickerData: { date: null, name: 'Due Date', field: 'due_on' },
    onHold: true,
    countyURL: null,
    defaultCounty: null,
    order: {
      client_reference: null,
      first_borrower: null,
      last_4_of_ssn: null,
      second_borrower: null,
      last_4_of_ssn_2: null,
      price: null,
      subject_lien_amount: null,
      created_on: null,
      effective_date: null,
      prior_effective_date: null,
      subject_lien_date: null,
      prepared_date: null,
      search_pd_st_date: null,
      due_on: null,
      loan: null,
      note: null,
      on_hold: false,
      is_developer_deed: true,
      new_pps_recordings_found: true,
      is_effective_date_changed: true,
      borrower_name_in_title: true,
      addressLine: null,
      zip_code: null,
      client: null,
      city: null,
      ts_identifier: null
    },
    isVisible: false,
    customUiProductNames: PRODUCT_NAMES,
    shouldShowCustomUi: false
  }),
  mounted () {
    this.isVisible = JwtService.addOrderCheck()
  },
  methods: {
    getDateFromDatePicker (value) {
      console.log(value) // someValue
      if (value.field === 'due_on') {
        this.order[value.field] = value.date
      } else {
        this.order[value.field] = value.date + ' 00:00:00'
      }
      console.log(this.order)
    },
    createNewOrder (data) {
      // console.log(this.$refs.form)
      this.loading = true
      if (this.$refs.form.validate()) {
        this.$store.dispatch(ADDORDER, this.order)
          .then(response => {
            this.loading = false
            this.$emit('newOrderAdded', response)
            this.dialog = false
          })
          .catch(response => {
            this.loading = false
          })
        // .error(response => {
        //   alert('Something went worng, please check Order Data and retry! \n Here is the exact error from server: \n' + response)
        // })
      } else {
        // const errorFieldName = this.$refs.form.errors
        setTimeout(() => {
          let errorFirst = document.querySelector('.error--text')
          if (errorFirst) {
            const errorFirstInput = errorFirst.querySelector('input, select')
            errorFirst.scrollIntoView({ behavior: 'instant' })
            errorFirstInput.focus()
          }
        }, 400)
        this.loading = false
      }
    },
    getAutoCompleteData (data) {
      if (data.__field === 'product') {
        this.shouldShowCustomUi = false
        if (this.customUiProductNames.includes(data.name)) {
          this.shouldShowCustomUi = true
        }
      }
      if (data.__type === 'foriegn') {
        this.order[data.__field] = data.id
        if (data.__field === 'state') {
          this.countyURL = `counties/?state__id=${data.id}`
        }
      } else {
        this.order[data.__field] = data
      }
      console.log(this.order)
      if (['product', 'county', 'state', 'client'].includes(data.__field)) {
        this.getProductFees()
      }
    },
    getProductFees () {
      if (this.order.client !== undefined && this.order.product !== undefined && this.order.state !== undefined && this.order.county !== undefined) {
        let payload = {
          client__id: this.order.client,
          product__id: this.order.product,
          state__id: this.order.state,
          county__id: this.order.county
        }
        this.$store.dispatch(GETCLIENTPRODUCTFEES, payload)
          .then(response => {
            if (response.count > 0) {
              this.order.price = response.results[0].prices.toFixed(2)
              this.loading = false
            } else {
              this.orderObj.price = ''
            }
          })
          .catch(response => {
            this.loading = false
          })
      }
    },
    productCleared () {
      this.shouldShowCustomUi = false
    }
  }
}
</script>
<style scoped>
.radio-group-container,.v-input--selection-controls{
  margin-top:0px;
  margin-bottom:0px !important;
}
::v-deep .v-input__slot{
  margin-bottom:0px !important;
}
::v-deep .v-input--radio-group__input>.v-label{
margin-right:40px;
}
</style>
